window.addEventListener('load', function() {
  function applyCustomStyles() {
    var style = document.createElement('style');
    style.innerHTML = `
      .pr-reviewsnippet, .pr-reviewdisplay, .pr-irlsnippet {
        max-width: 100% !important;
        margin: 0 auto !important;
        text-align: center !important;
      }

      .pr-stars, .pr-rating-count {
        display: inline-block !important;
        font-size: 1.2em !important;
      }

      @media (max-width: 768px) {
        .pr-stars, .pr-rating-count {
          font-size: 1em !important;
        }
      }

      @media (max-width: 480px) {
        .pr-stars, .pr-rating-count {
          font-size: 0.8em !important;
        }
      }

      /* Additional styles to ensure the container is flexible */
      .product-card {
        display: flex;
        flex-direction: column;
        height: auto !important;
        overflow: visible !important;
      }

      .product-card .product-featured-image,
      .product-card .product-card-info {
        flex: 1 1 auto;
        height: auto !important;
        overflow: visible !important;
      }
    `;
    document.head.appendChild(style);
  }

  function forceRepaint() {
    var evt = window.document.createEvent('UIEvents'); 
    evt.initUIEvent('resize', true, false, window, 0); 
    window.dispatchEvent(evt);
  }

  // Apply styles immediately after the full load
  applyCustomStyles();
  forceRepaint();

  // Reapply styles and force repaint after PowerReviews are rendered
  document.addEventListener('PowerReviewsLoaded', function() {
    applyCustomStyles();
    forceRepaint();
  }, false);
});
